import Top from "./Top";
export default Top;